<template>
<!-- Core Promise -->
    <section class="core-promise">
        <h2 class="section-title">Two Ways Pabu Helps You Every Day</h2>
        <div class="two-column">
            <div class="feature-column">
                <h3>⚡ Handles the Busy Work</h3>
                <p>So you can focus on what you do best</p>
                <ul class="feature-list">
                    <li>Integrates with your website as a virtual shopping assistant</li>
                    <li>Answers customer inquiries 24/7—bookings, orders, or questions</li>
                    <li>Automates your business workflows end-to-end</li>
                    <li>Manages appointments, orders, follow-ups, and reminders</li>
                </ul>
            </div>
            <div class="feature-column">
                <h3>🧠 Shows You What's Working</h3>
                <p>So you can make informed decisions</p>
                <ul class="feature-list">
                    <li>Performance insights</li>
                    <li>Growth opportunities</li>
                    <li>Strategic suggestions</li>
                    <li>Industry benchmarks</li>
                </ul>
            </div>
        </div>
        <p class="tagline">"You decide. Pabu executes and advises."</p>
    </section>  
</template>

<script>
export default {
  name: "WhoWeAreSection"
  /*
  data() {
    return {
      image1: require("@/assets/images/abouts-1.jpg"),
      image2: require("@/assets/images/abouts-2.jpg"),
      graphic1: "https://csimg.nyc3.cdn.digitaloceanspaces.com/Images/Graphics/splash-4.svg",
      graphic2: "https://csimg.nyc3.cdn.digitaloceanspaces.com/Images/Graphics/tire-mark.svg",
      features: [
        "Daily Personal Activities & Assistance",
        "Travel & Transport Support",
        "Community & Social Participation",
        "Household Task Assistance",
        "Community Nursing Care"
      ]
    };
  }*/
};
</script>

<style scoped>

</style>
